import { render } from "./SummaryStats.vue?vue&type=template&id=6a870f46&scoped=true"
import script from "./SummaryStats.vue?vue&type=script&lang=js"
export * from "./SummaryStats.vue?vue&type=script&lang=js"

import "./SummaryStats.vue?vue&type=style&index=0&id=6a870f46&scoped=true&lang=css"

import exportComponent from "/home/lexmodo/Vue/FraudLabs/fraudlabs_vue/fraudlabs_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a870f46"]])

export default __exports__